var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 12.4375H10.4375V11.3125H4.8125V12.4375ZM4.8125 9.4375H10.4375V8.3125H4.8125V9.4375ZM3.35581 15.25C2.97694 15.25 2.65625 15.1188 2.39375 14.8563C2.13125 14.5938 2 14.2731 2 13.8942V2.35581C2 1.97694 2.13125 1.65625 2.39375 1.39375C2.65625 1.13125 2.97694 1 3.35581 1H9.3125L13.25 4.9375V13.8942C13.25 14.2731 13.1188 14.5938 12.8563 14.8563C12.5938 15.1188 12.2731 15.25 11.8942 15.25H3.35581ZM8.75 5.5V2.125H3.35581C3.29806 2.125 3.24519 2.14906 3.19719 2.19719C3.14906 2.24519 3.125 2.29806 3.125 2.35581V13.8942C3.125 13.9519 3.14906 14.0048 3.19719 14.0528C3.24519 14.1009 3.29806 14.125 3.35581 14.125H11.8942C11.9519 14.125 12.0048 14.1009 12.0528 14.0528C12.1009 14.0048 12.125 13.9519 12.125 13.8942V5.5H8.75Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/Claim.2c9e8eab81412c51702619b6addab1db.svg";
export { ForwardRef as ReactComponent };